export const APP_VERSION = "sw release v5.01";

// Public-only route paths that should not show sidebar/header.
// Imported by both index.jsx and router.jsx to avoid duplication.
// Values must stay in sync with RouteEnum.
export const AUTH_PATHS = [
  "/login",
  "/signup",
  "/register",
  "/accept-invite",
  "/mfa-verify",
  "/mfa-setup",
  "/onboarding/create-company",
];
